<div class="confirm-main">
    <h1 mat-dialog-title
        class="draggable-dialogue-header"
        cdkDrag
        cdkDragRootElement=".cdk-overlay-pane"
        cdkDragHandle>
        Move Item
    </h1>

    <div>
        <mat-icon class="confirm-icon">warning</mat-icon>
    </div>

    <div mat-dialog-content>
        <div *ngIf="showMoveOrRepositionPrompt" [innerHTML]="message"></div>
        <p *ngIf="!showMoveOrRepositionPrompt" class="message">{{message}}</p>
    </div>

    <div mat-dialog-actions class="confirm-buttons">
        <button mat-raised-button color="primary" class="theme-primary-btn" [mat-dialog-close]="'move'">Move</button>

        <button mat-button [mat-dialog-close]="null">Cancel</button>
    </div>
</div>
